// removed by extract-text-webpack-plugin
module.exports = {"ScrollLoader":"ScrollLoader","opened":"opened"};


//////////////////
// WEBPACK FOOTER
// ./src/components/scroll-loader/styles.css
// module id = 799
// module chunks = 0 1